import $ from 'jquery';
import 'parsleyjs';
import './Language/parsley';
import 'emailDecrypt';
import 'picturefill';
import 'foreachfill';
import 'custom-event-polyfill';

// import './Libraries/LFM/BreakpointEvents';
import './Lightbox';
import './Select';
import './Menu';
import './Slider';
import './NavToggle';
// import './CookieConsent';
import './Cardbox';
import './SquareTeaser';
import './LogoCollection';
import './Search';
import './Header';
import './NumberedSlider';
import './ObjectHighlight';
import './Infobar';
import './HelpInterferer';
import './NewsletterSign';
import './NewsletterBar';
import './Tender';
// import './BackToTop';
// import './LazyLoad';
// import './Gallery';
import './Youtube';
// import './Maps';
// import './Accordion';
import './Datepicker';
import './Form';

var isDev = process.env.NODE_ENV !== 'production';

if (isDev) {
    console.log('%cTheme.js successfully initialized with webpack! 🌊☀', "color: green");
}
$(window).trigger('resize');  // trigger once on page load
